const Counter1 = () => {
  return (
    <section className="counter-area" style={{ position: "relative" }}>

    </section>
  );
};
export default Counter1;
